import border from '../../border';

const dark = (params) => border.disabled.dark(params);

export default dark;
